import open from "open";
import { readProject } from "../lib/config.js";
import { api } from "../lib/api.js";

interface App {
  slug: string;
  app_token?: string;
}

export async function openCommand(slug: string): Promise<void> {
  let appToken: string | undefined;

  const project = readProject();
  if (project?.slug === slug && project.app_token) {
    appToken = project.app_token;
  }

  if (!appToken) {
    const res = await api.get("/v1/apps");
    if (res.ok) {
      const apps = (await res.json()) as App[];
      const app = apps.find((a) => a.slug === slug);
      appToken = app?.app_token;
    }
  }

  let url = `https://${slug}.apps.clawnify.com`;
  if (appToken) {
    url += `?token=${appToken}`;
  }

  await open(url);
  console.log("Opened in browser");
}
